import {
  Empty,
  EmptyDescription,
  EmptyHeadline,
  EmptyDrawerIcon,
} from '@frontend/legacy-components';

export default function EmptyOptionalGroups() {
  return (
    <Empty size="sm">
      <EmptyDrawerIcon />
      <EmptyHeadline>Refine search terms</EmptyHeadline>
      <EmptyDescription>No matching organizations found</EmptyDescription>
    </Empty>
  );
}
